import { SnackbarService } from './snackbar.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
})
export class SnackbarComponent implements OnInit {
  constructor(public service: SnackbarService) {}

  ngOnInit(): void {}
}
